const trustMetrics = [
  { icon: 'ri-checkbox-circle-line', value: '+50.000', label: 'produtos verificados' },
  { icon: 'ri-user-star-line', value: '+500', label: 'vendedores analisados' },
  { icon: 'ri-refresh-line', value: 'Diário', label: 'atualizado diariamente' },
  { icon: 'ri-shield-check-line', value: '100%', label: 'links seguros e revisados' },
];

export default function TrustSection() {
  return (
    <section className="bg-background-100 py-14 md:py-20">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-12">
          <span className="inline-block border border-accent-300 text-accent-700 text-xs font-medium px-4 py-1 rounded-full mb-4">
            Confiança
          </span>
          <h2 className="font-heading font-bold text-2xl md:text-4xl text-foreground-950 leading-tight max-w-2xl mx-auto">
            O portal mais completo<br />para compras seguras
          </h2>
          <p className="mt-3 text-sm text-foreground-600 max-w-lg mx-auto">
            Milhares de compradores confiam no nosso CSSBuy Spreadsheet diariamente
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6 max-w-4xl mx-auto">
          {trustMetrics.map((metric) => (
            <div
              key={metric.label}
              className="bg-background-50 rounded-2xl p-6 md:p-8 text-center hover:bg-accent-50 transition-colors duration-300 group cursor-default"
            >
              <div className="w-12 h-12 mx-auto mb-4 flex items-center justify-center rounded-xl bg-accent-100 group-hover:bg-accent-200 transition-colors">
                <i className={`${metric.icon} text-xl text-accent-600`}></i>
              </div>
              <div className="font-heading font-extrabold text-2xl md:text-3xl text-foreground-950 mb-1">
                {metric.value}
              </div>
              <p className="text-xs text-foreground-500 leading-relaxed">
                {metric.label}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}